import React from "react"
import { View as RNView, Text as RNText } from "react-native"

const createAnimatableComponent = (Component: any) => {
  return React.forwardRef(({ animation, duration, delay, ...props }: any, ref: any) => {
    return React.createElement(Component, { ...props, ref })
  })
}

const AnimatableView = createAnimatableComponent(RNView)
const AnimatableText = createAnimatableComponent(RNText)

// Funções necessárias para react-native-modal
export const initializeRegistryWithDefinitions = () => {}
export const registerAnimation = () => {}
export const createAnimation = () => ({})

export const View = AnimatableView
export const Text = AnimatableText

export default {
  createAnimatableComponent,
  initializeRegistryWithDefinitions,
  registerAnimation,
  createAnimation,
  View: AnimatableView,
  Text: AnimatableText,
}
